import { SavedSearch } from '@creditsights/api-ui-web';
import { pickBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { DATE_FORMATS } from '../../../Base.constants';

export const getSavedSearchQueryParams = ({ keywords, filters, dateRange, sort, tab }: SavedSearch): string => {
  const { startDate, endDate, relativeRange } = dateRange ?? {};
  const queryParams = {
    searchTerm: keywords,
    startDate: formatSavedSearchDate(startDate),
    endDate: formatSavedSearchDate(endDate),
    dateRelativeRange: relativeRange || '',
    sort,
    category: tab,
  };
  const validQueryParams = pickBy<string>(queryParams);

  filters.forEach((filter) => {
    validQueryParams[filter.filterType] = filter.tags.map((tag) => tag.tagId);
  });

  return createSearchParams(validQueryParams as Record<string, string | string[]>).toString();
};

const formatSavedSearchDate = (date?: string): string => {
  if (!date) {
    return '';
  }
  const parsedDate = parseISO(date);

  return format(parsedDate, DATE_FORMATS.YEAR_MONTH_DAY);
};
